// Mounts realtime notification listener for authenticated layout (Reverb or legacy WS).

import { useAuth } from "../../../app/modules/auth";
import { useNotificationSocket } from "../../../hooks/useWebSocketNotification";

export const NotificationInit = () => {
    const { auth } = useAuth();
    useNotificationSocket(auth);
    return null;
};
